<div class="action-panel sopcard-panel">
  <div class="sopcard-header" (click)="accordionAction()">
    <i class="fa fa-user" style="margin-right:6px;"></i>
    <span class="sopcard-title">Personal information</span>
    <i class="fa sopcard-chevron" [ngClass]="opened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </div>

  <div *ngIf="opened" class="action-panel-body">

    <!-- ── Basic ──────────────────────────────────────────────────────────── -->
    <h6 class="sopcard-section-title">Profile</h6>
    <div class="row">
      <div class="col-md-6">
        <div class="detail-field"><label>Name</label><p><span *ngIf="epe.version == 'v2'">{{ epe.title }} </span>{{ epe.name }}</p></div>
        <div class="detail-field"><label>Organisation</label><p>{{ epe.organisation || '—' }}</p></div>
        <div class="detail-field"><label>LinkedIn</label>
          <p>
            <a *ngIf="epe.linkedin" [href]="epe.linkedin" target="_blank" rel="noopener">Open profile</a>
            <span *ngIf="!epe.linkedin">—</span>
          </p>
        </div>
        <div class="detail-field"><label>Phone</label><p>{{ epe.phone_number || '—' }}</p></div>
      </div>
      <div class="col-md-6">
        <div class="detail-field"><label>Surname</label><p>{{ epe.surname || '—' }}</p></div>
        <div class="detail-field"><label>Email</label><p>{{ epe.email || '—' }}</p></div>
        <div class="detail-field"><label>Country</label><p>{{ epe.country || '—' }}</p></div>
        <div class="detail-field"><label>Gender</label><p>{{ epe.gender || '—' }}</p></div>
      </div>
    </div>

    <!-- ── Topics ─────────────────────────────────────────────────────────── -->
    <h6 class="sopcard-section-title">Topics</h6>
    <ul class="topic-tree" *ngFor="let topic of getTopicTags()">
      <li class="topic-l1">
        <span class="topic-name-l1">{{ topic }}</span>
        <ul *ngFor="let tag of getTopicTags(topic)">
          <li class="topic-l2">
            <span class="topic-name-l2">{{ tag }}</span>
            <ul *ngFor="let t of getTopicTags(topic, tag)">
              <li class="topic-l3">{{ t }}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>

    <!-- ── Employment (v2) ────────────────────────────────────────────────── -->
    <ng-container *ngIf="epe.version == 'v2'">
      <h6 class="sopcard-section-title">Current position</h6>
      <div class="row">
        <div class="col-md-6">
          <div class="detail-field"><label>Organisation</label><p>{{ epe.organisation || '—' }}</p></div>
          <div class="detail-field"><label>Position</label><p>{{ epe.position || '—' }}</p></div>
        </div>
        <div class="col-md-6">
          <div class="detail-field"><label>Organisation type</label><p>{{ epe.organisation_type || '—' }}</p></div>
          <div class="detail-field"><label>Start date</label><p>{{ epe.position_dates || '—' }}</p></div>
        </div>
      </div>

      <h6 class="sopcard-section-title" *ngIf="epe.previous_positions?.length">Previous positions</h6>
      <div *ngFor="let pos of epe.previous_positions; let i = index" class="sopcard-subsection">
        <div class="sopcard-subsection-title">Position {{ i + 1 }}</div>
        <div class="row">
          <div class="col-md-3"><div class="detail-field"><label>From</label><p>{{ pos.from || '—' }}</p></div></div>
          <div class="col-md-3"><div class="detail-field"><label>To</label><p>{{ pos.to || '—' }}</p></div></div>
          <div class="col-md-3"><div class="detail-field"><label>Employer</label><p>{{ pos.employer || '—' }}</p></div></div>
          <div class="col-md-3"><div class="detail-field"><label>Position held</label><p>{{ pos.position_held || '—' }}</p></div></div>
        </div>
      </div>

      <h6 class="sopcard-section-title" *ngIf="epe.academic_qualifications?.length">Academic qualifications</h6>
      <div *ngFor="let q of epe.academic_qualifications; let i = index" class="sopcard-subsection">
        <div class="sopcard-subsection-title">Qualification {{ i + 1 }}</div>
        <div class="row">
          <div class="col-md-3"><div class="detail-field"><label>From</label><p>{{ q.from || '—' }}</p></div></div>
          <div class="col-md-3"><div class="detail-field"><label>To</label><p>{{ q.to || '—' }}</p></div></div>
          <div class="col-md-3"><div class="detail-field"><label>Institution</label><p>{{ q.higher_education || '—' }}</p></div></div>
          <div class="col-md-3"><div class="detail-field"><label>Qualification</label><p>{{ q.academic_qualification || '—' }}</p></div></div>
        </div>
      </div>
    </ng-container>

    <!-- ── Expertise ──────────────────────────────────────────────────────── -->
    <h6 class="sopcard-section-title" *ngIf="epe.standardisation_roles?.length">Expertise</h6>
    <div *ngFor="let role of epe.standardisation_roles; let i = index" class="sopcard-subsection">
      <div class="sopcard-subsection-title">Role {{ i + 1 }}</div>
      <div class="row">
        <div class="col-md-6">
          <div class="detail-field" *ngIf="role.represent || (epe.version == 'v1' && role.other_represent)">
            <label>Represent</label>
            <p>{{ role.represent || (epe.version == 'v1' && role.other_represent) }}</p>
          </div>
          <div class="detail-field"><label>Role</label><p>{{ role.role || '—' }}</p></div>
          <div class="detail-field"><label>Years of experience</label><p>{{ role.years || '—' }}</p></div>
        </div>
        <div class="col-md-6">
          <ng-container *ngIf="epe.version == 'v1'">
            <div class="detail-field">
              <label>TC / SC / WG</label>
              <div [innerHTML]="role.details || '—'"></div>
            </div>
          </ng-container>
          <ng-container *ngIf="epe.version == 'v2'">
            <div class="detail-field"><label>Number TC/SC/WG</label><p>{{ role.number_sdo || '—' }}</p></div>
            <div class="detail-field"><label>Title TC/SC/WG</label><p>{{ role.title_sdo || '—' }}</p></div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- ── About (v2) ─────────────────────────────────────────────────────── -->
    <ng-container *ngIf="epe.version == 'v2' && epe.tell_us_more">
      <h6 class="sopcard-section-title">About</h6>
      <div class="detail-field">
        <div [innerHTML]="epe.tell_us_more"></div>
      </div>
    </ng-container>

    <!-- ── CV ─────────────────────────────────────────────────────────────── -->
    <h6 class="sopcard-section-title">CV</h6>
    <div *ngIf="epe.cv" class="file-row">
      <i class="fa fa-file-pdf-o"></i>
      <a [href]="'https://hsbooster.eu/' + epe.cv" target="_blank" rel="noopener">Download CV</a>
    </div>
    <p *ngIf="!epe.cv" class="text-muted" style="margin:0;">—</p>

  </div>
</div>

<!-- ── Evaluation Summary (call manager) ───────────────────────────────────── -->
<div *ngIf="auth.isCallManager() && epe.sop_status != 'pending' && epe.sop_status != 'not_eligible'"
     class="action-panel sopcard-panel">
  <div class="sopcard-header" (click)="accordionAction(true)">
    <i class="fa fa-star-half-o" style="margin-right:6px;"></i>
    <span class="sopcard-title">Evaluation Summary</span>
    <i class="fa sopcard-chevron" [ngClass]="votesOpened ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
  </div>

  <div *ngIf="votesOpened" class="action-panel-body">
    <div class="table-responsive">
      <table class="table table-hover vote-table">
        <thead>
          <tr>
            <th>Voted by</th>
            <th>Roles & Years (30%)</th>
            <th>TWG Participation (30%)</th>
            <th>Other Expertise (30%)</th>
            <th>Gender (10%)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of getVoteIterable()">
            <td>{{ row.voter }}</td>
            <td>{{ vote!.automatic }}<small> /10</small></td>
            <td>{{ row.engagment }}<small> /10</small></td>
            <td>{{ row.standardisation }}<small> /10</small></td>
            <td>{{ vote!.gender }}<small> /10</small></td>
          </tr>
          <tr class="vote-avg-row">
            <td><strong>Average</strong></td>
            <td><strong>{{ !vote ? 0 : vote!.automatic }}</strong><small> /10</small></td>
            <td><strong>{{ getVoteAvg(false) }}</strong><small> /10</small></td>
            <td><strong>{{ getVoteAvg(true) }}</strong><small> /10</small></td>
            <td><strong>{{ !vote ? 0 : vote!.gender }}</strong><small> /10</small></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
